<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <el-form ref="formValidate" :model="model" :rules="rules" label-width="320px">
                    <el-form-item label="登录后跳转到：" prop="home_page" v-if="advance_manager">
                        <el-select clearable v-model="model.home_page" placeholder="请选择">
                            <el-option v-for="item in enuObj('home_page')" :key="'home_page'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="水泥比重(g/cm3)：" prop="water_mud_proportion">
                        <el-input v-model="model.water_mud_proportion"></el-input>
                    </el-form-item>
                    <el-form-item label="砂比重(g/cm3)：" prop="sand_proportion">
                        <el-input v-model="model.sand_proportion"></el-input>
                    </el-form-item>
                    <el-form-item label="监测单位：" prop="monitor_company">
                        <el-input v-model="model.monitor_company" style="width: 400px"></el-input>
                    </el-form-item>
                    <el-form-item label="项目部：" prop="project_part">
                        <el-input v-model="model.project_part" style="width: 400px"></el-input>
                    </el-form-item>
                    <el-form-item label="报告监测是否报警：" prop="work_report_alert" v-if="advance_manager">
                        <el-select clearable v-model="model.work_report_alert" placeholder="请选择">
                            <el-option v-for="item in enuObj('yesNo')" :key="'yesNo'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="作业报告监控天数：" prop="work_report_alert_days" v-if="advance_manager">
                        <el-input v-model="model.work_report_alert_days" style="width: 400px"></el-input>
                    </el-form-item>
                    <el-form-item label="停工开始日期：" prop="downtime_s">
                        <el-date-picker v-model="model.downtime_s" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="停工结束日期：" prop="downtime_e">
                        <el-date-picker v-model="model.downtime_e" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="作业报告监控通知用户名：" prop="notice_username" v-if="advance_manager">
                        <el-input v-model="model.notice_username" style="width: 400px"></el-input>
                        <div class="tips">多个用户请用英文“;”隔开</div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSubmit" size="medium">保 存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel, getModelById} from '@/api/common'

export default {
    name: 'projectConfigEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                water_mud_proportion: '',
                sand_proportion: '',
                monitor_company: '',
                project_part: '',
                work_report_alert: '',
                work_report_alert_days: '',
                downtime_s: '',
                downtime_e: '',
                notice_username: '',
                advance_manager: false,
                home_page: ''
            },
            getObj:{
                url:'/api/admin/projectconfig/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['yesNo', 'home_page'],
            rules: {
                home_page: [
                    {required: true, message: '登录后跳转页不能为空', trigger: 'blur'}
                ],
                water_mud_proportion: [
                    {required: true, message: '水泥比重不能为空', trigger: 'blur'}
                ],
                sand_proportion: [
                    {required: true, message: '砂比重不能为空', trigger: 'blur'}
                ],
                monitor_company: [
                    {required: true, message: '监测单位不能为空', trigger: 'blur'}
                ],
                work_report_alert: [
                    {required: true, message: '报告监测是否报警不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    mounted() {
        this.loadData()
    },
    methods: {
        getModelData() {
            this.model = this.copyObj(this.init_model);
            getModelById(this.getObj).then(res => {
                if (res.code === 1) {
                    this.model = res.data.projectConfig;
                    this.advance_manager =res.data.advance_manager;
                    if (this.exits_p_name != '') {
                        this.old_check = this.model[this.exits_p_name];
                    }
                    this.formateData();
                } else {
                    this.$msg(res.msg)
                    this.closeDialog()
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/projectconfig/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData() {
            this.model.work_report_alert = this.model.work_report_alert+""
            this.model.home_page = this.model.home_page+""
        },
    }
};
</script>